export default {
  'SAVE_COMPANY' (state, payload) {
    state.company = payload
    window.localStorage.setItem('company', JSON.stringify(state.company))
  },
  'CHANGE_USER' (state, payload) {
    payload = Object.assign({}, state.user, payload)
    state.user = payload
    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  'CHANGE_EMAIL' (state, payload) {
    state.email = payload
    window.localStorage.setItem('email', JSON.stringify(state.email))
  },
  'UNSET_USER' (state) {
    state.user = false
    window.localStorage.removeItem('user')
  },
  'SAVE_NEIGHBORHOOD' (state, payload) {
    payload = Object.assign({}, state.neighborhood, payload)
    state.neighborhood = payload
    window.localStorage.setItem('neighborhood', JSON.stringify(state.neighborhood))
  },
  'CHANGE_RENT_PRE_REGISTRATION' (state, payload) {
    payload = Object.assign({}, state.rentPreRegistration, payload)
    state.rentPreRegistration = payload
    window.localStorage.setItem('rent_pre_registration', JSON.stringify(payload))
  },
  'UNSET_RENT_PRE_REGISTRATION' (state) {
    state.rentPreRegistration = false
    window.localStorage.removeItem('rent_pre_registration')
  },
  'SAVE_RENT' (state, payload) {
    state.rent = payload
    window.localStorage.setItem('rent', JSON.stringify(state.rent))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js